export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
  { name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
  { name: "Pants/Shorts", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html" },
  { name: "Headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html" },
  { name: "Sets", url: "https://kaspreadsheet.com/category-917-Sets.html" },
  { name: "Underwear/Underpants", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html" },
  { name: "Jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html" },
  { name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
  { name: "Bags", url: "https://kaspreadsheet.com/category-921-Bags.html" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Bags.html" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Bags.html" },
  { name: "OtherStuff", url: "https://kaspreadsheet.com/search-924/name/Bags.html" },
];

export const articleClusters = [
  {
    title: "What is OOPBuy Spreadsheet?",
    subtitle: "Complete 2026 Guide for Beginners",
    path: "/what-is-oopbuy-spreadsheet",
    cluster: "guide",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20office%20desk%20with%20laptop%20showing%20spreadsheet%20data%20charts%20minimal%20workspace%20with%20notebook%20and%20coffee%20soft%20natural%20lighting%20warm%20cream%20background%20editorial%20photography%20high%20detail%20professional%20aesthetic&width=800&height=1000&seq=article-guide-whatis-v2&orientation=portrait",
  },
  {
    title: "OOPBuy vs Manual Tracking",
    subtitle: "Which System is Right for You?",
    path: "/oopbuy-vs-manual-tracking",
    cluster: "comparison",
    imageUrl: "https://readdy.ai/api/search-image?query=Pristine%20white%20minimalist%20workspace%20showing%20notebook%20with%20handwritten%20notes%20beside%20laptop%20with%20digital%20spreadsheet%20soft%20natural%20lighting%20clean%20cream%20background%20editorial%20photography%20professional%20aesthetic&width=800&height=1000&seq=article-compare-vs-v2&orientation=portrait",
  },
  {
    title: "Best Template for 2026",
    subtitle: "Advanced Tracking System Setup",
    path: "/best-oopbuy-spreadsheet-template",
    cluster: "commercial",
    imageUrl: "https://readdy.ai/api/search-image?query=Contemporary%20minimalist%20workspace%20with%20large%20monitor%20displaying%20colorful%20spreadsheet%20charts%20and%20graphs%20clean%20desk%20with%20keyboard%20soft%20natural%20light%20warm%20cream%20background%20editorial%20photography&width=800&height=1000&seq=article-best-tmpl-v2&orientation=portrait",
  },
  {
    title: "OOPBuy Beginner Guide",
    subtitle: "Step-by-Step Setup for New Users",
    path: "/oopbuy-spreadsheet-beginner-guide",
    cluster: "guide",
    imageUrl: "https://readdy.ai/api/search-image?query=Welcoming%20clean%20workstation%20with%20laptop%20showing%20simple%20tutorial%20screen%20notebook%20with%20pen%20beside%20warm%20coffee%20mug%20soft%20natural%20lighting%20cream%20background%20editorial%20photography%20friendly%20professional%20aesthetic&width=800&height=1000&seq=article-beginner-v2&orientation=portrait",
  },
  {
    title: "How to Use OOPBuy Spreadsheet",
    subtitle: "Practical Tips and Workflow Guide",
    path: "/how-to-use-oopbuy-spreadsheet",
    cluster: "guide",
    imageUrl: "https://readdy.ai/api/search-image?query=Organized%20modern%20desk%20with%20macbook%20displaying%20spreadsheet%20interface%20hands%20typing%20notebook%20with%20checklist%20pen%20soft%20warm%20natural%20light%20cream%20background%20editorial%20photography%20professional&width=800&height=1000&seq=article-howto-v2&orientation=portrait",
  },
  {
    title: "OOPBuy vs Google Sheets",
    subtitle: "Which Spreadsheet Tool Wins?",
    path: "/oopbuy-vs-google-sheets",
    cluster: "comparison",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20comparison%20scene%20left%20side%20laptop%20with%20oopbuy%20spreadsheet%20right%20side%20tablet%20with%20google%20sheets%20interface%20clean%20minimal%20background%20soft%20lighting%20cream%20editorial%20photography&width=800&height=1000&seq=article-vs-gsheets-v2&orientation=portrait",
  },
  {
    title: "OOPBuy vs Airtable",
    subtitle: "Database vs Spreadsheet for Tracking",
    path: "/oopbuy-vs-airtable",
    cluster: "comparison",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20desk%20setup%20with%20two%20monitors%20one%20displaying%20spreadsheet%20interface%20other%20displaying%20database%20view%20clean%20minimal%20workspace%20soft%20natural%20lighting%20cream%20background%20editorial&width=800&height=1000&seq=article-vs-air-v2&orientation=portrait",
  },
  {
    title: "Track Suppliers Efficiently",
    subtitle: "Supplier Management Best Practices",
    path: "/how-to-track-suppliers-efficiently",
    cluster: "problem",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20workspace%20with%20laptop%20displaying%20supplier%20comparison%20dashboard%20organized%20documents%20spreadsheet%20printouts%20clean%20minimal%20background%20soft%20lighting%20cream%20editorial%20photography&width=800&height=1000&seq=article-supplier-v2&orientation=portrait",
  },
  {
    title: "Calculate Profit in Spreadsheets",
    subtitle: "Automated Profit Margin Guide",
    path: "/how-to-calculate-profit-in-spreadsheet",
    cluster: "problem",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20desk%20with%20laptop%20displaying%20profit%20calculator%20interface%20with%20charts%20and%20numbers%20calculator%20beside%20notebook%20soft%20natural%20lighting%20cream%20background%20editorial%20photography&width=800&height=1000&seq=article-profit-v2&orientation=portrait",
  },
  {
    title: "Common Tracking Mistakes",
    subtitle: "Avoid These E-commerce Pitfalls",
    path: "/common-mistakes-in-product-tracking",
    cluster: "problem",
    imageUrl: "https://readdy.ai/api/search-image?query=Thoughtful%20workspace%20with%20laptop%20showing%20warning%20notification%20on%20spreadsheet%20scattered%20sticky%20notes%20with%20reminders%20clean%20minimal%20background%20soft%20lighting%20cream%20editorial%20photography&width=800&height=1000&seq=article-mistakes-v2&orientation=portrait",
  },
  {
    title: "Advanced Tracking System",
    subtitle: "Power User Features Explained",
    path: "/advanced-oopbuy-tracking-system",
    cluster: "commercial",
    imageUrl: "https://readdy.ai/api/search-image?query=Sleek%20modern%20workstation%20with%20ultrawide%20monitor%20displaying%20complex%20spreadsheet%20dashboards%20multiple%20data%20visualizations%20clean%20minimal%20desk%20soft%20lighting%20cream%20background%20editorial&width=800&height=1000&seq=article-advanced-v2&orientation=portrait",
  },
  {
    title: "Automated Product Spreadsheet",
    subtitle: "Full Automation Walkthrough",
    path: "/automated-product-spreadsheet",
    cluster: "commercial",
    imageUrl: "https://readdy.ai/api/search-image?query=Futuristic%20clean%20workspace%20with%20laptop%20displaying%20automated%20spreadsheet%20workflows%20with%20glowing%20data%20connections%20minimal%20desk%20setup%20soft%20natural%20lighting%20cream%20background%20editorial&width=800&height=1000&seq=article-auto-v2&orientation=portrait",
  },
];

export const aboutFeatures = [
  {
    title: "Fast Bulk Import",
    description: "Import hundreds of products in seconds with our optimized spreadsheet pipeline. Designed for high-volume resellers who need speed and accuracy.",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20with%20laptop%20showing%20file%20import%20interface%20with%20progress%20bar%20papers%20beside%20soft%20natural%20lighting%20cream%20background%20editorial%20photography%20minimalist&width=600&height=400&seq=about-feat-import-v2&orientation=landscape",
  },
  {
    title: "Auto Profit Calculation",
    description: "Built-in formulas automatically calculate margins, fees, and net profit. Make data-driven decisions without manual number crunching.",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20profit%20calculator%20dashboard%20with%20charts%20and%20percentage%20indicators%20soft%20natural%20lighting%20cream%20background%20editorial%20photography&width=600&height=400&seq=about-feat-profit-v2&orientation=landscape",
  },
  {
    title: "Supplier Management",
    description: "Track multiple suppliers, compare pricing, and manage inventory levels all from a single unified spreadsheet dashboard.",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20desk%20with%20laptop%20displaying%20supplier%20comparison%20table%20with%20ratings%20organized%20documents%20beside%20soft%20natural%20lighting%20cream%20background%20editorial%20photography&width=600&height=400&seq=about-feat-supplier-v2&orientation=landscape",
  },
  {
    title: "Real-time Analytics",
    description: "Monitor sales trends, profit patterns, and performance metrics with live-updating charts and visual data summaries.",
    imageUrl: "https://readdy.ai/api/search-image?query=Sleek%20workspace%20with%20laptop%20showing%20real-time%20analytics%20dashboard%20with%20live%20charts%20and%20graphs%20clean%20minimal%20desk%20soft%20lighting%20cream%20background%20editorial&width=600&height=400&seq=about-feat-analytics-v2&orientation=landscape",
  },
];

export const statsData = [
  { value: "10K+", label: "Active Users" },
  { value: "50+", label: "Categories Tracked" },
  { value: "99%", label: "Accuracy Rate" },
  { value: "24/7", label: "System Access" },
];